import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { startGetAsistencias } from "../../context/actions/asistenciasActions";
import CardPage from "../../layout/CardPage";
import { Tabla } from "./Tabla";

export default function Home() {
  const { asistencias, ultimasFechas } = useSelector((state) => state.asistenciasReducer);
  const dispatch = useDispatch();

  //
  useEffect(() => {
    const interval = setInterval(() => {
      if (ultimasFechas.fechaInicio && ultimasFechas.fechaFin) {
        dispatch(startGetAsistencias(ultimasFechas.fechaInicio, ultimasFechas.fechaFin));
      }
    }, 60000);
    return () => clearInterval(interval);
  }, [dispatch, ultimasFechas]);

  ///
  return (
    <CardPage titulo={`  Asistencias: ${asistencias.length}`}>
      <Tabla />
    </CardPage>
  );
}
